import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bluebird.webp';
import screenshot_target from '../../../images/letterfunnel/machielkunst.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Machiel Kunst"
      firstname="Machiel"
      companyname="Bluebird"
      competition="Nobala en ACELR8"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/machielkunst.js